export const FILTER_HIDE_GATHERINGS = 'showGatherings'
export const FILTER_HIDE_BUSINESSES = 'showBusinesses'
export const FILTER_CATEGORIES = 'categories'
export const FILTER_REGIONS = 'regions'
export const FILTER_CITIES = 'cities'
